/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Radio from 'backbone.radio';

import { userHasRole } from '@/util/RoleUtils';

import CommandOrderGridView from '../CommandOrderGridView';

import tmplCommandOrdersView from './CommandOrdersView.hbs';
const CommandOrderView = View.extend({
  template: tmplCommandOrdersView,

  ui: {
    commandOrderGridContainer: '.command-order-grid-container',
    addOrderButton: '.add-order-button'
  },

  regions: {
    commandOrderGridContainer: '@ui.commandOrderGridContainer'
  },

  events: {
    'click @ui.btnDownloadCSV': 'onClickDownloadCSV',
    'click @ui.addOrderButton': 'onClickAddOrder'
  },

  onRender() {
    if (!userHasRole('CRS') && !userHasRole('Admin')) {
      this.ui.addOrderButton.hide();
    }
    this.commandOrderGridContainer = new CommandOrderGridView({
      model: this.model
    });
    this.showChildView('commandOrderGridContainer', this.commandOrderGridContainer);
  },

  onClickAddOrder() {
    Radio.channel('navigate').request('show:int:order:create-order', this.model.get('commandId').commandId, true);
  }
});

export default CommandOrderView;
